import { PricingDto } from './pricing.dto';

export class Pricing {
    tax: number;
    profitMarginDiamond: number;
    profitMarginMaterial: number;
    profitMarginLabour: number;
    profitMarginRod: number;
    addingUpProfitMargin: boolean;

    constructor(data: PricingDto) {
        this.tax = parseFloat(data.tax);
        this.profitMarginDiamond = parseFloat(data.profitMarginDiamond);
        this.profitMarginMaterial = parseFloat(data.profitMarginMaterial);
        this.profitMarginLabour = parseFloat(data.profitMarginLabour);
        this.profitMarginRod = data.profitMarginRod !== null ? parseFloat(data.profitMarginRod) : 0;
        this.addingUpProfitMargin = data.addingUpProfitMargin;
    }
}
